const loadScript = done => {
  const script = document.createElement('script');
  script.async = true;
  // script.src = 'https://wchat.freshchat.com/js/widget.js';
  script.src = '//fw-cdn.com/4083664/3147116.js';
  script.setAttribute("chat",'true');
  script.setAttribute("widgetId","22c5f72e-00f5-4480-89a9-2bb212b07dad");
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
  script.onload = done;
};

export default loadScript;